export interface Call {
  callSid: string;
  status?: string;
  creationDate: Date;
  callDuration?: number;
  phoneNumberTo: string;
  phoneNumberFrom?: string;
  userCaller?: CallUserType;
  userCallee?: CallUserType;
  callReason?: CallReason;
  conferenceName?: string;
}

export enum CallUserTypeEnum {
  FITTER = 'FITTER',
  CUSTOMER = 'CUSTOMER',
  INSURER = 'INSURER',
}

export type CallUserType = `${CallUserTypeEnum}`;
export enum CallReasonEnum {
  APPOINTMENT_MODIFICATION = 'APPOINTMENT_MODIFICATION',
  SPARE_PART_INFORMATION = 'SPARE_PART_INFORMATION',
  CUSTOMER_CALL = 'CUSTOMER_CALL',
}
export type CallReason = `${CallReasonEnum}`;
